var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRedditWhite = function SvgRedditWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.07,
    height: 13.001,
    viewBox: "0 0 16.07 13.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reddit-white",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M-524-939c-3.86,0-7-2.243-7-5,0-.09,0-.178.011-.269A1.981,1.981,0,0,1-532-946a1.994,1.994,0,0,1,1.091-1.779A2.01,2.01,0,0,1-530-948a1.987,1.987,0,0,1,1.17.378,8.575,8.575,0,0,1,4.487-1.355l1.16-2.72a.5.5,0,0,1,.46-.3.505.505,0,0,1,.115.013l2.853.667A1.493,1.493,0,0,1-518.5-952a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5,1.493,1.493,0,0,1-1.485-1.347l-2.441-.57-.84,1.967a8.453,8.453,0,0,1,4.134,1.354,1.965,1.965,0,0,1,1.2-.4,2,2,0,0,1,2,2,1.968,1.968,0,0,1-1.077,1.768c0,.074.008.151.008.232C-517-941.243-520.14-939-524-939Zm-2.025-3.1a.5.5,0,0,0-.2.042.5.5,0,0,0-.3.41.5.5,0,0,0,.213.459,3.908,3.908,0,0,0,2.309.749,3.907,3.907,0,0,0,2.309-.749.5.5,0,0,0,.214-.459.5.5,0,0,0-.3-.41.5.5,0,0,0-.2-.042.5.5,0,0,0-.3.1,2.912,2.912,0,0,1-1.723.56,2.915,2.915,0,0,1-1.723-.56A.5.5,0,0,0-526.025-942.095Zm4.525-3.406a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-521.5-945.5Zm-5,0a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-526.5-945.5Zm8-5.5a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5A.5.5,0,0,0-518.5-951Z",
    transform: "translate(532 954)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedditWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reddit-white.1c7810d1.svg";
export { ForwardRef as ReactComponent };